import React from "react";
import {connect} from "react-redux";
import Field from "../simple/field";
import Grid from '@material-ui/core/Grid';
import {withTranslation} from "react-i18next";

class EducationDocument extends React.Component {
    constructor(props) {
        super(props);
        const {educationDocument} = this.props;
        this.state = {
            docType: educationDocument.doc_type,
        };
        this.changeDocType = this.changeDocType.bind(this);
    };
    changeDocType = (e) => {
        const docType = Number(e.target.value);
        this.setState({docType})
    };
    render() {
        const {changeDocType} = this;
        const {typesEducationDocuments, schemesEducationDocuments, educationDocument, refs, t} = this.props;
        const {docType} = this.state;
        const scheme = schemesEducationDocuments[docType];
        return (
            <React.Fragment>
                <input ref={input => refs['doc_id'] = input} type="hidden" defaultValue={educationDocument.doc_id} />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field
                            name="doc_type"
                            scheme={{label: t('document_type'), required: true, type: {data_source: 'inner', format: 'single_select', values: typesEducationDocuments}}}
                            defaultValue={educationDocument.doc_type}
                            refs={refs}
                            onChange={changeDocType}
                            disabled={educationDocument.doc_id !== undefined} />
                    </Grid>
                    {scheme
                        ? Object.keys(scheme.struct).map((fieldName) => {
                            return (
                                <Grid item xs={12} key={fieldName}>
                                    <Field
                                        name={fieldName}
                                        scheme={scheme.struct[fieldName]}
                                        defaultValue={educationDocument[fieldName]}
                                        refs={refs} />
                                </Grid>
                            );
                        })
                        : null}
                </Grid>
            </React.Fragment>
        );
    }
}
function mapStateToProps(state) {
    return {
        typesEducationDocuments: state.typesEducationDocuments,
        schemesEducationDocuments: state.schemesEducationDocuments,
    };
}

export default connect(mapStateToProps)(withTranslation()(EducationDocument));